module.exports = __webpack_public_path__ + "img/caption.d726d26f.png";